import { ReplyCommentModel } from '@app/inputs/inputs-api.model';

// When a typeguard returns true, it's telling the TS compiler
// that this variable is a specfic type. This is useful when a function
// is working with a variable number of types and they need to be narrowed down.
// See more here: https://rangle.io/blog/how-to-use-typescript-type-guards/

export function isFunction<T extends Function>(v: any): v is T {
  return typeof v === 'function';
}

export function isBoolean(v: any): v is boolean {
  return typeof v === 'boolean';
}

/**
 * Determines if a the given value is a date.
 */
export function isDate(v: any): v is Date {
  return Object.prototype.toString.call(v) === '[object Date]';
}

export const isReplyCommentModel = (item: any): item is ReplyCommentModel => {
  return 'parentId' in item;
};
